module.exports = __webpack_public_path__ + "static/img/hala26.dae7ace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala26.jpg
// module id = 0aZ7
// module chunks = 1